import { Endpoint } from '../endpoint';

export const ProcessingRule = new Endpoint('processing_rule');
